/** Valor de auditoría que el backend usa cuando la acción la dispara un proceso interno. */
export const SYSTEM_ACTOR = 'system';

/** Nombre de quien creó o actualizó un registro; sin resolver, «—» en vez del identificador. */
export function actorDisplayName(
    actor: string | undefined,
    adminNameBySub: ReadonlyMap<string, string>,
): string {
    if (!actor) return '—';
    if (actor === SYSTEM_ACTOR) return 'Sistema';
    return adminNameBySub.get(actor)?.trim() || '—';
}
